// 七牛图片前缀
export const PIC_PREFIX = 'http://picture.aismile.cn/';
// 七牛上传地址
export const UPLOAD_URL = 'https://up.qiniup.com';
